import { rpcClient } from "@/api/WebsocketClient"
import { reactive } from '@vue/reactivity'
import Message from '@/model/Message';


export default class GeneratedMessageStore {

    state = reactive({
        messages: new Map<number, Message>(),
        calls: new Map<string, number | number[]>()
    })

    constructor() {
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.stores.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    clearState() {
        if (this.state?.messages) this.state.messages.clear()
        if (this.state?.calls) this.state.calls.clear()
    }

    addOrReplaceMessage(newMessage: Message) {
        if (newMessage.id) {
            this.state.messages.set(newMessage.id, newMessage)
            
        }
    }

    addOrReplaceMessages(newMessages: Message[]) {
        for (const newMessage of newMessages) {
            this.addOrReplaceMessage(newMessage)
        }
    }

    replaceMessages(messages: Message[]) {
        const newMessages = new Map<number, Message>()
        for (const newMessage of messages) {
            if (newMessage.id) {
                newMessages.set(newMessage.id, newMessage)
                
            }
        }
        this.state.messages = newMessages
    }

    removeMessage(id: number | undefined | null) {
        if (id !== undefined && id !== null) {
            this.state.messages.delete(id)
        }
    }

    removeMessages(ids: (number | null)[] | undefined | null) {
        if (ids !== undefined && ids !== null) {
            for (const id of ids) {
                this.removeMessage(id)
            }
        }
    }
}